import { ProjectSurveyOverview, ProjectSurveyProjectDashboard } from '@ygtechnologies/bygr-frontend-component-library';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Trans } from '@lingui/react/macro';
import { Tabs } from '@ygtechnologies/rubus-ui';
import { IState } from '@/state/IState';
import { useGetActiveProfile } from '@/utils/hooks';

interface ProjectSurveyProps {
    projectId: number;
}

export const ProjectSurvey: React.FC<ProjectSurveyProps> = ({ projectId }) => {
    const profile = useGetActiveProfile();
    const user = useSelector((state: IState) => state.global.user);
    const [activeTab, setActiveTab] = useState<'dashboard' | 'setup'>('dashboard');

    if (!profile || !user) {
        return null;
    }

    return (
        <>
            <Tabs activeId={activeTab} variant="underline">
                <Tabs.Tab id="dashboard" label={<Trans>Dashboard</Trans>} onClick={() => setActiveTab('dashboard')} />
                <Tabs.Tab id="setup" label={<Trans>Setup</Trans>} onClick={() => setActiveTab('setup')} />
            </Tabs>
            {activeTab === 'dashboard' && <ProjectSurveyProjectDashboard projectId={projectId} />}
            {activeTab === 'setup' && (
                <ProjectSurveyOverview profileId={profile.id} projectId={projectId} applicationUserId={user.userId} />
            )}
        </>
    );
};
